import envDetect from '@tcc/env-detect';
import { isImpersonating, isProxyingItself } from './isImpersonating';
import { ROUTE } from '../constants/routes';

function hideByUrl(route: string): boolean {
  return route.includes(ROUTE.Connect) || route.includes(ROUTE.Programs);
}

/**
 * Determines whether to show opertions; only show if user is not proxying or on Salesforce or on
 * a web app only meant for single-operation use - this excludes Settings, DMB, and Programs
 * (VAlora/DKB experience), since selecting an operation has no effect there.
 * The Dashboard operation selector is additionally gated behind the
 * `web-dashboard-operation-selector` feature flag.
 * @param {Object} user
 * @param {String} route
 * @param {Record<string, boolean> | null} featureFlags
 * @return {Boolean}
 */
export function shouldShowOperationSelector({
  user,
  route,
  featureFlags = null,
}: {
  user: unknown;
  route: string;
  featureFlags?: Record<string, boolean> | null;
}) {
  const onSalesforce = envDetect.isSalesforce();
  if (hideByUrl(route) || onSalesforce) {
    return false;
  }

  if (route.includes(ROUTE.Dashboard) && !featureFlags?.['web-dashboard-operation-selector']) {
    return false;
  }

  return (!isImpersonating(user) && !isProxyingItself(user));
}
